/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetBrandSitemapRequest} from '@cash-web/protos/squareup/cash/local/v1/cash_app_local_web_service.pb'
import {GetBrandSitemapResponse} from '@cash-web/protos/squareup/cash/local/v1/cash_app_local_web_service.pb'


export const getBrandSitemap = (request: GetBrandSitemapRequest, options?: CashRequestOptions) => post<GetBrandSitemapRequest, GetBrandSitemapResponse>("/2.0/cash/get-brand-sitemap", request, {...options, rejectOnError: true })